import { render, staticRenderFns } from "./addOpenVillage.vue?vue&type=template&id=27874805&"
import script from "./addOpenVillage.vue?vue&type=script&lang=js&"
export * from "./addOpenVillage.vue?vue&type=script&lang=js&"
import style0 from "./addOpenVillage.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports